import axios from "axios";
import Config from "../utils/Config";

class UserService {
  config = {
    headers: {
      Authorization: "",
      GroupId: "",
      CompanyId: "",
    },
  };

  setAccessToken(accessToken, groupId, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.GroupId = groupId;
    this.config.headers.CompanyId = companyId;
  }

  //create user
  async createUser(accessToken, groupId, companyId, formData) {
    this.setAccessToken(accessToken, groupId, companyId);

    const data = await axios.post(
      Config.BACKEND_URL + "/api/user", //api/user
      formData,
      this.config
    );
    return data.data;
  }

  //update user
  async updateUser(accessToken, groupId, companyId, id, formData) {
    this.setAccessToken(accessToken, groupId, companyId);

    const data = await axios.put(
      Config.BACKEND_URL + `/api/user/${id}`, //api/user/:id
      formData,
      this.config
    );
    return data.data;
  }

  //get user by id
  async getUserById(accessToken, groupId, companyId, id) {
    this.setAccessToken(accessToken, groupId, companyId);
    const data = await axios.get(
      Config.BACKEND_URL + `/api/user/${id}`, //api/group/:id
      this.config
    );
    return data.data;
  }

  //get members for logged user
  async getMembersForLoggedUser(accessToken, groupId, companyId) {
    this.setAccessToken(accessToken, groupId, companyId);
    const sanitizedGroupId = groupId || "";
    const sanitizedCompanyId = companyId || "";
    const data = await axios.get(
      Config.BACKEND_URL +
        `/api/user/getMembersForLoggedUser?groupId=${sanitizedGroupId}&companyId=${sanitizedCompanyId}`, //api/user/getMembersForLoggedUser?
      this.config
    );
    return data.data;
  }

  //get all user types
  async getAllUserTypes(accessToken, groupId, companyId) {
    this.setAccessToken(accessToken, groupId, companyId);
    const data = await axios.get(
      Config.BACKEND_URL + "/api/role/roleDropDown", //api/role/roleDropDown
      this.config
    );
    return data.data;
  }

  //get profile picture
  async getProfilePicture(accessToken, groupId, companyId, userId) {
    this.setAccessToken(accessToken, groupId, companyId);
    //console.log(userId);
    const data = await axios.get(
      Config.BACKEND_URL + `/api/user/userProfile/${userId}`, //api/user/userProfile/{userId}
      this.config
    );
    return data.data;
  }

  //update user for profile
  async updateMe(accessToken, groupId, companyId, formData) {
    this.setAccessToken(accessToken, groupId, companyId);

    const data = await axios.patch(
      Config.BACKEND_URL + `/api/user/updateMe`, ///api/user/updateMe'
      formData,
      this.config
    );
    return data.data;
  }

  //change user password
  async updateMyPassword(accessToken, groupId, companyId, passwordData) {
    this.setAccessToken(accessToken, groupId, companyId);

    const data = await axios.patch(
      Config.BACKEND_URL + `/api/user/updateMyPassword`, ///api/user/updateMyPassword'
      passwordData,
      this.config
    );
    return data.data;
  }

  //delete profile picture
  async deleteMyProfilePicture(accessToken, groupId, companyId, userId) {
    this.setAccessToken(accessToken, groupId, companyId);

    const data = await axios.delete(
      Config.BACKEND_URL + `/api/user/${userId}/delete-profile-picture`,
      this.config
    );
    return data.data;
  }

    //unlock user
    async unlockUser(accessToken, groupId, companyId, userId) {
      this.setAccessToken(accessToken, groupId, companyId);
      const data = await axios.patch(
        Config.BACKEND_URL + `/api/user/unlockUser/${userId}`,
        {},
        this.config,
      );
      return data.data;
    }

  //update the Email noification
  async setEmailNotificationMessage(accessToken, groupId, companyId, formData) {
    this.setAccessToken(accessToken, groupId, companyId);

    const data = await axios.patch(
      Config.BACKEND_URL + `/api/user/isMailNotification`, ///api/user/updateMe'
      formData,
      this.config
    );
    return data.data;
  }

  async getGuideVideosLink(accessToken, groupId, companyId) {
    this.setAccessToken(accessToken, groupId, companyId);

    const data = await axios.get(
      Config.BACKEND_URL + "/api/user/guide-videos-link",
      this.config
    );
    return data.data;
  }

}

export default new UserService();
